/**
 * The five media kinds' guards — `EntrySlice.guard`, once the registry (#312) binds each.
 */

import type { Entry } from '@/document'
import { MEDIA_KINDS } from './meta'
import type {
  BookEntry,
  MovieEntry,
  ArtistEntry,
  ReleaseEntry,
  LabelEntry,
  MediaKind,
} from './meta'

/**
 * Whether a widened type string names one of the five media kinds.
 *
 * The one guard here that takes a string rather than an `Entry`: its callers hold a detected type
 * from analysis, which has no entry yet. Out of `useEntryAnalysis.ts`'s `isMediaType` on #397.
 */
export function isMediaKind(type: string | null): type is MediaKind {
  return type !== null && (MEDIA_KINDS as readonly string[]).includes(type)
}

export function isBookEntry(entry: Entry): entry is BookEntry {
  return entry.type === 'book'
}

export function isMovieEntry(entry: Entry): entry is MovieEntry {
  return entry.type === 'movie'
}

export function isArtistEntry(entry: Entry): entry is ArtistEntry {
  return entry.type === 'artist'
}

export function isReleaseEntry(entry: Entry): entry is ReleaseEntry {
  return entry.type === 'release'
}

export function isLabelEntry(entry: Entry): entry is LabelEntry {
  return entry.type === 'label'
}
